<template>
  <Modal :modalActive="active" @close="$emit('dismissed')">
    <div class="consent-card">
      <div class="consent-icon">
        <i class="fa fa-envelope-o" aria-hidden="true"></i>
      </div>
      <h4 class="consent-title">Stay in the loop?</h4>
      <p class="consent-subtitle">Get occasional emails about new features, tips, and offers. You can unsubscribe anytime.</p>
      <div class="consent-actions">
        <button @click="respond(true)" class="consent-btn consent-btn-primary" :disabled="submitting">
          Yes, keep me posted
        </button>
        <button @click="respond(false)" class="consent-btn consent-btn-secondary" :disabled="submitting">
          No thanks
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal-Base'
import UserService from '../../services/user.service'

export default {
  name: 'MarketingConsentModal',
  components: { Modal },
  props: ['active'],
  emits: ['answered', 'dismissed'],
  data() {
    return {
      submitting: false
    }
  },
  methods: {
    respond (consent) {
      if (this.submitting) return
      this.submitting = true
      UserService.updateEmailMarketingConsent(consent).then(() => {
        this.submitting = false
        this.$emit('answered', consent)
      })
    }
  }
}
</script>

<style scoped>
.modal :deep(.modal-inner) {
  width: auto;
  max-width: 420px;
  padding: 40px 32px 32px 32px;
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(75, 79, 202, 0.18);
}

.modal :deep(.modal-inner i.fa-times-circle) {
  display: block;
  margin: 0;
  color: #cbd5e1;
  font-size: 18px;
  top: 18px;
  right: 18px;
}

.modal :deep(.modal-inner i.fa-times-circle:hover) {
  color: #64748b;
}

.consent-card {
  text-align: center;
}

.consent-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #595ca7 0%, #6266d6 50%, #56438e 100%);
  box-shadow: 0 6px 16px rgba(75, 79, 202, 0.3);
}

.consent-icon i {
  display: block;
  margin: 0;
  font-size: 26px;
  line-height: 1;
  color: #fff;
}

.consent-title {
  font-size: 20px;
  font-weight: 700;
  color: #213343;
  margin-bottom: 10px;
}

.consent-subtitle {
  font-size: 14px;
  line-height: 1.6;
  color: #64748b;
  margin-bottom: 28px;
}

.consent-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.consent-btn {
  width: 100%;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s, transform 0.15s, background-color 0.2s;
}

.consent-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.consent-btn-primary {
  background: #5b3dd8;
  color: #fff;
}

.consent-btn-primary:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-1px);
}

.consent-btn-secondary {
  background: transparent;
  color: #64748b;
}

.consent-btn-secondary:hover:not(:disabled) {
  background: #f1f5f9;
  color: #213343;
}
</style>
